import hrms27uLabels from 'assets/labels/hrms27u'
import moment from 'moment'
import faker from 'faker'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hrms27uLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        numappl: faker.random.number(),
        desc_numappl: faker.name.findName(),
        desc_codpos: faker.name.jobType(),
        numreql: faker.random.word(),
        emprcname: faker.name.findName(),
        dteappoi: moment().format('DD/MM/YYYY'),
        codpos1: '',
        codposl: '',
        statappl: '',
        staappr: mockStatus[staappr]
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms27u/mocker.js